/**
 * Shopify Lazy Loader
 * Ekrana giren elementleri yükler — sıfır bağımlılık, ~4KB
 *
 * Desteklenenler:
 *   <img data-src="...">                    → resimler
 *   <img data-srcset="...">                 → responsive resimler
 *   <source data-srcset="...">              → picture/video source
 *   <video data-src="...">                  → videolar
 *   <iframe data-src="...">                 → iframeler (app embed vb.)
 *   style="background:url(?)"  →  data-bg="..." → arka plan görselleri
 *   <div data-section-lazy>                 → Shopify section'ları
 *   <div class="lazyload-fade">             → fade-in animasyon
 */

(function () {
  'use strict';

  /* ─── AYARLAR ─────────────────────────────────────── */
  var CONFIG = {
    rootMargin: '200px 0px',   // ekrana 200px kala yüklemeye başla
    threshold: 0,
    imageClass: 'spz-lazy',    // class ile de işaretleyebilirsin
    fadeClass: 'spz-fade',     // fade animasyonu için
    loadedClass: 'spz-loaded',
    errorClass: 'spz-error',
    placeholderColor: 'transparent', // yüklenmeden önce arkaplan
    debug: false,              // true yaparsan console log açılır
  };

  /* ─── CSS: fade animasyonu ────────────────────────── */
  var style = document.createElement('style');
  style.textContent = [
    '.spz-fade{opacity:0;transition:opacity .4s ease}',
    '.spz-fade.spz-loaded{opacity:1}',
    'img[data-src]:not(.spz-loaded){background:' + CONFIG.placeholderColor + '}',
    '[data-bg]:not(.spz-loaded){background-color:' + CONFIG.placeholderColor + '}',
  ].join('');
  document.head.appendChild(style);

  function log() {
    if (CONFIG.debug) console.log('[SPZ]', Array.prototype.join.call(arguments, ' '));
  }

  /* ─── IntersectionObserver yoksa hepsini yükle ────── */
  if (!('IntersectionObserver' in window)) {
    log('IntersectionObserver yok, fallback ile hepsini yüklüyorum');
    loadAll();
    return;
  }

  /* ─── OBSERVER ────────────────────────────────────── */
  var io = new IntersectionObserver(onIntersect, {
    rootMargin: CONFIG.rootMargin,
    threshold: CONFIG.threshold,
  });

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      load(el);
      io.unobserve(el);
    });
  }

  /* ─── YÜKLEME MANTIKLARI ──────────────────────────── */
  function load(el) {
    var tag = el.tagName.toLowerCase();

    if (tag === 'img') {
      loadImg(el);
    } else if (tag === 'video') {
      loadVideo(el);
    } else if (tag === 'iframe') {
      loadIframe(el);
    } else if (el.hasAttribute('data-bg')) {
      loadBg(el);
    } else if (el.hasAttribute('data-section-lazy')) {
      loadSection(el);
    } else {
      // picture içindeki source elementleri
      loadPictureSources(el);
    }
  }

  /* Resim */
  function loadImg(img) {
    var src = img.getAttribute('data-src');
    var srcset = img.getAttribute('data-srcset');
    var sizes = img.getAttribute('data-sizes') || img.getAttribute('sizes');

    if (!src && !srcset) return;

    var tmp = new Image();

    tmp.onload = function () {
      if (src) img.src = src.startsWith('//') ? 'https:' + src : src;
      if (srcset) img.srcset = srcset;
      if (sizes) img.sizes = sizes;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.classList.add(CONFIG.loadedClass);
      log('img yüklendi:', src || srcset);
    };

    tmp.onerror = function () {
      img.classList.add(CONFIG.errorClass);
      log('img HATA:', src);
    };

var resolvedSrc = (src || srcset.split(' ')[0]);
if (resolvedSrc.startsWith('//')) resolvedSrc = 'https:' + resolvedSrc;
tmp.src = resolvedSrc;

    // picture içindeki source'ları da yükle
    var picture = img.parentElement;
    if (picture && picture.tagName.toLowerCase() === 'picture') {
      loadPictureSources(picture);
    }
  }

  /* Picture source */
  function loadPictureSources(container) {
    var sources = container.querySelectorAll('source[data-srcset]');
    sources.forEach(function (source) {
      source.srcset = source.getAttribute('data-srcset');
      source.removeAttribute('data-srcset');
    });
  }

  /* Video */
  function loadVideo(video) {
    var src = video.getAttribute('data-src');
    var sources = video.querySelectorAll('source[data-src]');

    sources.forEach(function (s) {
      s.src = s.getAttribute('data-src');
      s.removeAttribute('data-src');
    });

    if (src) {
      video.src = src;
      video.removeAttribute('data-src');
    }

    video.load();
    video.classList.add(CONFIG.loadedClass);
    log('video yüklendi');
  }

  /* İframe */
  function loadIframe(iframe) {
    var src = iframe.getAttribute('data-src');
    if (!src) return;
    iframe.src = src;
    iframe.removeAttribute('data-src');
    iframe.classList.add(CONFIG.loadedClass);
    log('iframe yüklendi:', src);
  }

  /* Background image */
  function loadBg(el) {
    var bg = el.getAttribute('data-bg');
    if (!bg) return;
    el.style.backgroundImage = 'url("' + bg + '")';
    el.removeAttribute('data-bg');
    el.classList.add(CONFIG.loadedClass);
    log('bg yüklendi:', bg);
  }

  /* Shopify Section — içindeki her şeyi tetikle */
  function loadSection(section) {
    section.removeAttribute('data-section-lazy');
    section.classList.add(CONFIG.loadedClass);
    // Section içindeki lazy elementleri gözlemle
    observe(section);
    log('section aktif edildi');
  }

  /* ─── GÖZLEM BAŞLAT ───────────────────────────────── */
  function observe(root) {
    root = root || document;

    // img[data-src], img[data-srcset]
    root.querySelectorAll('img[data-src], img[data-srcset]').forEach(function (el) {
      el.classList.add(CONFIG.fadeClass);
      io.observe(el);
    });

    // video[data-src]
    root.querySelectorAll('video[data-src]').forEach(function (el) {
      io.observe(el);
    });

    // source[data-src] (video içi)
    root.querySelectorAll('video:has(source[data-src])').forEach(function (el) {
      io.observe(el);
    });

    // iframe[data-src]
    root.querySelectorAll('iframe[data-src]').forEach(function (el) {
      io.observe(el);
    });

    // [data-bg]
    root.querySelectorAll('[data-bg]').forEach(function (el) {
      io.observe(el);
    });

    // [data-section-lazy] — Shopify section sarmalayıcılar
    root.querySelectorAll('[data-section-lazy]').forEach(function (el) {
      io.observe(el);
    });

    // class ile işaretlenenler
    root.querySelectorAll('.' + CONFIG.imageClass).forEach(function (el) {
      io.observe(el);
    });
  }

  /* Fallback: observer yoksa hepsini yükle */
  function loadAll() {
    document.querySelectorAll('img[data-src]').forEach(function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
    document.querySelectorAll('img[data-srcset]').forEach(function (img) {
      img.srcset = img.getAttribute('data-srcset');
      img.removeAttribute('data-srcset');
    });
    document.querySelectorAll('iframe[data-src]').forEach(function (el) {
      el.src = el.getAttribute('data-src');
    });
    document.querySelectorAll('[data-bg]').forEach(function (el) {
      el.style.backgroundImage = 'url("' + el.getAttribute('data-bg') + '")';
    });
  }

  /* ─── SHOPIFY SECTION RELOAD DESTEĞİ ─────────────── */
  // Shopify tema editöründe section yenilenince tekrar tarama yap
  document.addEventListener('shopify:section:load', function (e) {
    log('section reload, yeniden taranıyor');
    observe(e.target);
  });

  /* ─── BAŞLAT ──────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(); });
  } else {
    observe();
  }

  /* Geç yüklenen içerikler için global fonksiyon — JS'den çağırabilirsin */
  window.spzLazy = {
    observe: observe,
    load: load,
    refresh: function () { observe(document); },
  };

})();